export default "__VITE_ASSET__Dcf8nUq8__"